import withEditarPerfilProfesional from "../../hoc/withTrabajadores/withEditarResumenCv";
import EditarCv from "../../view/components/RegistroUsuarios/PerfilProfesional/EditarCv/EditarCv";

export default withEditarPerfilProfesional(EditarCv);